import React from 'react';
import { motion } from 'framer-motion';

const TechBackground = () => {
  return (
    <div className="tech-background">
      <svg width="100%" height="100%" className="tech-grid">
        <pattern id="tech-grid-pattern" x="0" y="0" width="50" height="50" patternUnits="userSpaceOnUse">
          <motion.path
            d="M 50 0 L 0 0 0 50"
            fill="none"
            stroke="rgba(56, 189, 248, 0.1)"
            strokeWidth="0.5"
            initial={{ pathLength: 0, opacity: 0 }}
            animate={{ pathLength: 1, opacity: 1 }}
            transition={{ duration: 2, repeat: Infinity, repeatType: "loop" }}
          />
        </pattern>
        <rect x="0" y="0" width="100%" height="100%" fill="url(#tech-grid-pattern)" />
      </svg>
      <div className="tech-circles">
        {[...Array(5)].map((_, i) => (
          <motion.div
            key={i}
            className="tech-circle"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ 
              scale: [1, 1.2, 1],
              opacity: [0.1, 0.2, 0.1]
            }}
            transition={{
              duration: 3,
              delay: i * 0.2,
              repeat: Infinity,
              repeatType: "reverse"
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default TechBackground;
